declare namespace $ {

	type $mol_check_icon__checked_shm_hitalama_map_book_tools_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools['drawing_checked'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_book_tools_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools['Drawing_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_book_tools_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools['rect_checked'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_book_tools_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools['Rect_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_book_tools_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools['circle_checked'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_book_tools_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book_tools['Circle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	export class $shm_hitalama_map_book_tools extends $mol_view {
		drawing_checked( next?: boolean ): boolean
		Drawing_icon( ): $mol_icon_pencil
		Drawing( ): $mol_check_icon
		rect_checked( next?: boolean ): boolean
		Rect_icon( ): $mol_icon_rectangle_outline
		Rect( ): $mol_check_icon
		circle_checked( next?: boolean ): boolean
		Circle_icon( ): $mol_icon_circle_outline
		Circle( ): $mol_check_icon
		tool_mode( next?: string ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tools.view.tree.d.ts.map